import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '@/app/store';

interface ConfirmModalState {
  editedForm: boolean;
  isUserInForm: boolean;
  showConfirmLeave: boolean;
  isFormEmpty: boolean;
  confirmPath: string;
}

const initialState: ConfirmModalState = {
  editedForm: false,
  isUserInForm: false,
  showConfirmLeave: false,
  isFormEmpty: false,
  confirmPath: '',
};

export const confirmModalSlice = createSlice({
  name: 'confirmModalSlice',
  initialState,
  reducers: {
    setIsUserInForm: (state, action) => {
      state.isUserInForm = action.payload;
    },
    setShowConfirmLeave: (state, action) => {
      state.showConfirmLeave = action.payload;
    },
    setEditedForm: (state, action) => {
      state.editedForm = action.payload;
    },
    setConfirmPath: (state, action) => {
      state.confirmPath = action.payload;
    },
  },
});

export const { setIsUserInForm, setShowConfirmLeave, setEditedForm, setConfirmPath } = confirmModalSlice.actions;

export const selectConfirmModal = (state: RootState) => state.confirmModal;

export default confirmModalSlice.reducer;
